export function isNonNullObject(param) {
    return param != null && typeof param === 'object';
}
